import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['text'];

	display() {
		const element = this.textTarget;
		if (!element.classList.contains('hidden')) {
			this.hide();
		} else {
			element.classList.remove('hidden');
		}
	}

	hide() {
		const element = this.textTarget;
		element.classList.add('hidden');
	}
}
